<template>
  <nav
    aria-label="subjects"
    class="w-75vw md:w-96 mx-auto bg-primary border normal-scroll"
  >
    <header class="subject-list__header relative py-2 md:py-4 bg-black text-white">
      <p>Which subject area are you interested in?</p>
    </header>
    <ul
      class="h-72 md:h-64 mobile-landscape:h-45vh py-5 px-3 bg-primary overflow-auto"
    >
      <li
        v-for="subject in subjects"
        :key="subject.slug"
        class="normal-scroll font-graphiklight"
      >
        <RouterLink
          :to="{
            name: 'content',
            params: {
              category_id: subject.slug,
              media_id: subject.slug
            }
          }"
          class="block mb-3 focus-a"
          :class="{ 'hover:underline hover:font-bold focus:underline focus:font-bold': !touch }"
          v-html="subject.title"
        />
      </li>
    </ul>
  </nav>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'SubjectMenu',

  props: {
    subjects: {
      type: Array,
      default: () => []
    },
    category: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    ...mapState([ 'touch', 'mobile' ]),
    ...mapGetters([ ])
  }
}
</script>
